import axiosInstance from "../../apiAxios/axiosInstance";
export const getSheduleList = async (payload) => {
  const response = await axiosInstance.post("/vendor/visits",payload);
  return response.data;
};